var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.661,
    height: 15.662,
    viewBox: "0 0 15.661 15.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21222",
    "data-name": "Group 21222",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10877",
    "data-name": "Path 10877",
    d: "M15.789,16A4.577,4.577,0,0,1,6.9,17.552l-2.62,2.1A7.827,7.827,0,0,0,19.039,16",
    transform: "translate(-3.378 -8.169)",
    fill: "#00ac47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10878",
    "data-name": "Path 10878",
    d: "M22.42,16A4.574,4.574,0,0,1,20.5,19.723l2.59,2.072A7.8,7.8,0,0,0,25.671,16",
    transform: "translate(-10.009 -8.169)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10879",
    "data-name": "Path 10879",
    d: "M6,13.476a4.549,4.549,0,0,1,.276-1.552l-2.62-2.1a7.788,7.788,0,0,0,0,7.3l2.62-2.1A4.549,4.549,0,0,1,6,13.476Z",
    transform: "translate(-2.75 -5.645)",
    fill: "#ffba00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10880",
    "data-name": "Path 10880",
    d: "M8.718,13.374Z",
    transform: "translate(-5.191 -7.095)",
    fill: "#2ab2db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10881",
    "data-name": "Path 10881",
    d: "M11.209,6a4.55,4.55,0,0,1,2.694.884l2.4-2.239A7.81,7.81,0,0,0,4.285,6.933l2.62,2.1A4.584,4.584,0,0,1,11.209,6Z",
    transform: "translate(-3.378 -2.75)",
    fill: "#ea4435"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10882",
    "data-name": "Path 10882",
    d: "M8.718,18.626Z",
    transform: "translate(-5.191 -9.243)",
    fill: "#2ab2db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10883",
    "data-name": "Path 10883",
    d: "M24.035,14.591v.591l-1.33,2.069H16.5V14h6.944A.591.591,0,0,1,24.035,14.591Z",
    transform: "translate(-8.374 -7.351)",
    fill: "#4285f4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f875d98adad771f36705d5edba7d5f09.svg";
export { ForwardRef as ReactComponent };